import React from "react";

export const Error = ({ children }) => {
  return <div className="error">{children}</div>;
};
